<template lang="">
  <div class="d-flex justify-start flex-column header-gambit">
    <h3 class="pt-15 text-h4 font-weight-bold">{{title}}</h3>
    <p :style="!hasClass ? 'margin-bottom: 30px': 'margin-bottom: 64px'">{{subtitle}}</p>
    <hr v-if="hasSeparator" class="separator">
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Bem-vindo ao Dashboard Gambit'
    },
    subtitle: {
      type: String,
      default: 'Ferramenta usada para fazer disparos em SMS ou push notification para os usuários da área logada.'
    },
    hasSeparator: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    hasClass () {
      if (this.$route.path === '/facebook') {
        return false
      }
      return true
    }
  }
}
</script>
<style lang="">
.separator {
  position: absolute;
  top: 233px;
  left: 333px;
  width: 100%;
}
.v-slide-group__content {
  display: flex !important;
  justify-content: flex-start !important;
  background: var(--grey-day-010);
}


.header-gambit .v-application .text-h3, .v-application .text-h4 {
    font-family: 'DM Sans Regular', sans-serif !important;
    font-size: 38px;
    color: #161927;
    line-height: 42px;
}

.header-gambit p {
    font-family: DM Sans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    color: #4F5963;
    /* margin-bottom: 64px !important; */
}


/* .v-application--is-ltr .v-tabs--centered>.v-tabs-bar .v-tabs-bar__content>:first-child:not(.v-tabs-slider-wrapper), .v-application--is-ltr .v-tabs--centered>.v-tabs-bar .v-tabs-slider-wrapper+*, .v-application--is-ltr .v-tabs--fixed-tabs>.v-tabs-bar .v-tabs-bar__content>:first-child:not(.v-tabs-slider-wrapper), .v-application--is-ltr .v-tabs--fixed-tabs>.v-tabs-bar .v-tabs-slider-wrapper+*, .v-application--is-rtl .v-tabs--centered>.v-tabs-bar .v-tabs-bar__content>:last-child, .v-application--is-rtl .v-tabs--fixed-tabs>.v-tabs-bar .v-tabs-bar__content>:last-child {
  margin-left: 0;
} */
</style>


// WEBPACK FOOTER //
// src/components/Header.vue